const SCRIP_DETAIL = {
	MARKET_DEPTH: 'Market depth',
	NO_DATA_AVAILABLE: 'No data available for selected criteria',
	READ_MORE: 'Read more',
	CONTACT_INFORMATION: 'Contact Information',
	ISIN: 'ISIN',
	VIEW_MORE: 'View more',
	ADDRESS: 'Address',
	TELEPHONE: 'Telephone',
	FAX: 'Fax',
	EMAIL: 'Email',
	WEBSITE: 'Website',
	YEAR: 'Year',
	EPS: 'EPS',
	PE: 'P/E',
	PEG: 'PEG',
	CURRENT_RATIO: 'Current ratio',
	DEBT_EQUITY_RATIO: 'Debt to Equity ratio',
	SHARES: 'Shares',
	MARKET_VALUE: 'Market value',
	SHAREHOLDING: 'Shareholding',
	PEER_COMPARISION: 'Peer comparison',
	ANNUAL_REPORT: 'Annual report',
	BALANCE_SHEET: 'Balance sheet',
	RESULTS: 'Results',
	PROFIT_LOSS: 'Profit & loss',
	SALSES_TURNOVER: 'Sales turnover/ Operating income',
	EXCISE_DUTY: 'Excise duty',
	NET_SALES: 'Net sales',
	OTHER_INCOME: 'Other income',
	NEWS_ANNOUNCEMENTS: 'News & announcements',
	CORPORATE_ACTION: 'Corporate action',
	BOARD_MEETING: 'Board meeting',
	BOOK_CLOSURE_NEWS: 'Book closure',
	AGM: 'AGM',
	EGM: 'EGM',
	SPLIT: 'Split',
	DIVIDEND: 'Dividend',
	BUYBACK: 'Buyback',
	BONUS: 'Bonus',
	RATIO: 'Ratio',
	RIGHT_ISSUE_DATE: 'Rights issue Date',
	NSE: 'NSE',
	BSE: 'BSE',
	SUPPORT_RESISTANCE: 'Support & resistance',
	SUPPORT: 'Support',
	RESISTANCE: 'Resistance',
	PIVOT: 'Pivot',
	LTP: 'LTP',
	PERCENT_CHANGE: '% Change',
	'1_yr_return': '1 yr return',
	M_CAP: 'M cap (Cr)',
	scripCodeDataAid: 'ticker',
	holdingsDataAid: 'portfolioValue',
	holdingsIconDataAid: 'portfolio',
	scripNameDataAid: 'scripName',
	logoDataAid: 'scripLogo',
	marketValueDataAid: 'marketValue',
	scripLogo: 'iv_scripLogo',
	portfolioPl: 'portfolioP&lValue&l',
	portfolioPlPercentage: 'portfolioP&lPercentage',
	marketValuePl: 'marketValueP&l',
	marketValuePlPercentage: 'marketValueP&lPercentage',
	liveStatus: 'status',
	scoreCard: {
		title: {
			dataAid: 'title',
		},
		subtitle: {
			dataAid: 'subtitle',
		},
	},
	lastUpdated: {
		text: 'Last updated:',
		dataAid: 'statusKey',
		valueDatAid: 'statusValue',
	},
};

const LIVE_STATS_STRING = {
	openInterest: {
		text: 'Open interest (OI)',
		dataAid: 'openInterestKey',
		valueDataAid: 'openInterestValue',
	},
	changeInOI: {
		text: 'Change in OI',
		dataAid: 'changeInOiKey',
		valueDataAid: 'changeInOiValue',
		perValueDataAid: 'changeInOiPercentage',
	},
	LIVE_SNAPSHOT: 'Live snapshot',
	OPEN: 'Open',
	HIGH: 'High',
	LOW: 'Low',
	CLOSE: 'Prev. close',
	LAST_TRADED_DATE: 'Last traded date',
	LAST_TRADED_QTY: 'Last traded qty',
	OPEN_INTEREST_OI: 'Open interest (OI)',
	CHANGE_IN_OI: 'Change in OI',
	AVG_TRADING_PRICE: 'Avg. traded price',
	VALUE: 'Value',
	VOLUME: 'Volume',
	TODAY_LOW: 'Today’s low ',
	TODAY_HIGH: 'Today’s high',
	'52_WEEK_LOW': '52 week low',
	'52_WEEK_HIGH': '52 week high',
	LOWER_CIRCUIT: 'Lower circuit',
	UPPER_CIRCUIT: 'Upper circuit',
	LOT_SIZE: {
		text: 'Lot size',
		dataAid: 'lot_size',
	},
	DAY_TO_EXPIRY: {
		text: 'Days to expiry',
		dataAid: 'days_to_expiry',
	},
};

const NEWS_EVENTS = {
	NEWS_ANNOUNCEMENTS: {
		container: {
			dataAid: 'grp_news&Announcements',
		},
		title: {
			dataAid: 'title',
			text: 'News & announcements',
		},
		button: {
			dataAid: 'viewMore',
			viewMore: 'View More',
			viewLess: 'View Less',
		},
		subtitle: {
			dataAid: 'subtitle',
		},
	},
	CORPORATE_ACTION: {
		BOARD_MEETING: 'Board meeting',
		BOOK_CLOSURE_NEWS: 'Book closure',
		RIGHTS: 'Rights',
		AGM: 'AGM',
		EGM: 'EGM',
		SPLIT: 'Split',
		DIVIDEND: 'Dividend',
		BUYBACK: 'Buyback',
		BONUS: 'Bonus',
		title: {
			dataAid: 'title',
			text: 'Corporate action',
		},
		container: {
			dataAid: 'grp_corporateAction',
		},
		boardMeeting: {
			title: {
				dataAid: 'title',
				text: 'Board meeting',
			},
			description: {
				dataAid: 'description',
			},
			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
		},
		rightsData: {
			RATIO: 'Ratio',
			RIGHT_ISSUE_DATE: 'Rights issue Date',
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},
			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
		},
		bookClosure: {
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},
			FROM: 'From',
			TO: 'To',
			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
		},
		splits: {
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},

			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
			SPLIT_DATE: 'Split Date',
			RATIO: 'Ratio',
		},
		dividend: {
			DIVIDEND_DATE: 'Dividend date',
			DIVIDEND_PER_SHARE: 'Dividend per share',
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},

			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
		},
		buyback: {
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},

			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
			MAX_AMOUNT: 'Max. Amount',
			START_DATE: 'Start date',
			END_DATE: 'End date',
		},
		bonus: {
			title: {
				dataAid: 'title',
			},
			description: {
				dataAid: 'description',
			},

			button: {
				dataAid: 'viewMore',
				viewMore: 'View More',
				viewLess: 'View Less',
			},
			BONUS_DATE: 'Bonus date',
			RATIO: 'Ratio',
		},
	},
};
const FUNDAMENTALS = {
	HEALTH_SCORE: {
		HEALTH_SCORE: 'Health score',
		POOR: 'Poor',
		FAIR: 'Fair',
		GOOD: 'Good',
		EXCELLENT: 'Excellent',
		WHAT_IS_HEALTH_SCORE: 'What is health score?',
		TOOLTIP_HEALTHSCORE:
			'Average price of stocks over a specific time period',
		container: {
			dataAid: 'grp_healthScore',
		},
		title: {
			text: 'Health score',
			dataAid: 'healthScore',
		},
		subtitle: {
			dataAid: 'score',
		},
		barMeter: {
			dataAid: 'healthScore',
		},
		note: {
			text: 'Understand health score',
			dataAid: 'healthScore',
		},
		tooltip: {
			text: 'Average price of stocks over a specific time period',
			dataAid: 'healthScore',
		},
		tooltipIcon: {
			dataAid: 'info',
		},
	},
	FINICIAL_RATIOS: {
		title: {
			text: 'Financial ratios',
			dataAid: 'financialRatios',
		},
		container: {
			dataAid: 'grp_financialRatios',
		},
		EPS: 'EPS',
		PE: 'P/E',
		PEG: 'PEG',
		DIVIDEND_YIELD: 'Dividend yield',
		CURRENT_RATIO: 'Current ratio',
		DEBT_EQUITY_RATIO: 'Debt to Equity ratio',
		EBTIDA_GROWTH: 'EBTIDA growth',
		PAT_GROWTH: 'PAT growth',
		NET_SALES_GROWTH: 'Net sales growth',
		QUICK_RATIO: 'Quick ratio',
		YEAR: 'Year',
		STANDALONE: 'Standalone',
		CONSOLIDATED: 'Consolidated',
	},
	PEER_COMPARISION: {
		title: {
			text: 'Peer comparison',
			dataAid: 'peerComparison',
		},
		container: {
			dataAid: 'grp_peerComparision',
		},
		OTHER_INCOME: 'Other income',
		scripName: {
			text: 'Stock name',
			dataAid: 'scripName',
		},
		ltp: {
			text: 'LTP',
			dataAid: 'ltp',
		},
		pe: {
			text: 'PE',
			dataAid: 'pe',
		},
		perChange: {
			text: '% Change',
			dataAid: 'perChange',
		},
		oneYearReturn: {
			text: '1 yr return',
			dataAid: '1yearReturn',
		},
		cap: {
			text: 'M cap (Cr)',
			dataAid: 'cap',
		},
	},
	annualReport: {
		title: {
			text: 'Annual report',
			dataAid: 'annualReport',
		},
	},
	TOP_MUTUAL_FUND_HOLDER: {
		title: {
			text: 'Top mutual fund holders',
			dataAid: 'mutualFundsInvested',
		},
		container: {
			dataAid: 'grp_mutualFundsInvested',
		},
		aum: {
			text: 'AUM',
			dataAid: 'aum',
		},
		shares: {
			text: 'Shares',
			dataAid: 'shares',
		},
		marketValue: {
			text: 'Market value',
			dataAid: 'marketValue',
		},
		button: {
			viewMore: 'View More',
			viewLess: 'View Less',
			dataAid: 'viewMore',
		},
	},
	QUARTERLY_TREND: {
		title: {
			text: 'Trend analysis',
			dataAid: 'trendAnalysis',
		},
	},
	SHARE_HOLDING: {
		title: {
			text: 'Shareholding',
			dataAid: 'shareHolding',
		},
	},
};

const TECHNICALS = {
	MOVING_AVERAGES: {
		title: {
			text: 'Moving averages',
			dataAid: 'movingAverages',
		},
		container: {
			dataAid: 'grp_movingAverages',
		},
		note: {
			text: 'Understand moving average',
			dataAid: 'note',
		},
		tooltip: {
			text: 'Average price of stocks over a specific time period',
			dataAid: 'movingAverage',
		},
		tooltipIcon: {
			dataAid: 'info',
		},
		DAYS_15: '15 Days',
		DAYS_20: '20 Days',
		DAYS_30: '30 Days',
		DAYS_50: '50 Days',
		DAYS_100: '100 Days',
		DAYS_150: '150 Days',
		DAYS_200: '200 Days',
		NSE: 'NSE',
		BSE: 'BSE',
		AVERAGES: 'Averages',
	},
	SUPPORT_RESISTANCE: {
		container: {
			dataAid: 'grp_supportAndResistance',
		},
		title: {
			dataAid: 'supportAndResistance',
			text: 'Support & resistance',
		},
		support: {
			text: 'Support',
			dataAid: 'support',
		},
		resistance: {
			text: 'Resistance',
			dataAid: 'resistance',
		},
		pivot: {
			text: 'Pivot',
			dataAid: 'pivot',
		},
	},
	DELIVERY_QUANTITY: {
		title: {
			text: 'Delivery quantity buildup',
			dataAid: 'deliveryQuanityBuildup',
		},
	},
};

const OPTION_CHAIN = {
	call: {
		text: 'Calls',
		dataAid: 'calls',
	},
	put: {
		text: 'Puts',
		dataAid: 'puts',
	},
	scripNameDataAid: 'title',
	scripMarketValueDataAid: 'marketValue',
	scripPL: 'marketP&L',
	strikePriceDataAid: 'strikePriceData',
	oiChangeLeftDataAid: 'oiChangeLeft',
	oiChangeRightDataAid: 'oiChangeRight',
	callPriceDataAid: 'callPrice',
	putPriceDataAid: 'putPrice',
};

const FO_VIEW = {
	futures: {
		title: {
			text: 'Futures',
			dataAid: 'future',
		},
		featureCard: {
			dataAidPrefix: 'grp_futureCard',
			dateKeyDataAid: 'dateKey',
			dateValueDataAid: 'dateValue',
			datePLDataAid: 'dateP&L',
			premium: {
				text: 'Premium/discount',
				dataAid: 'premiumKey',
			},
			premiumValueDataAid: 'premiumValue',
			totalOi: {
				text: 'Total OI',
				dataAid: 'totalOiKey',
			},
			changeOi: {
				text: 'Change in OI',
				dataAid: 'changeOiKey',
			},
			totalOiValueDataAid: 'totalOiValue',
			changeOiValueDataAid: 'changeOiValue',
		},
		underlying: {
			text: 'Underlying',
			dataAid: 'keyStats',
			marketPlDataAid: 'marketValueP&l',
			marketValPercDataAid: 'marketValuePercentage',
		},
		loadMore: 'Load more',
	},

	options: {
		container: {
			dataAid: 'mostActiveContracts',
		},
		title: {
			text: 'Options',
			dataAid: 'options',
		},
		activeContracts: {
			text: 'Most active contracts',
			dataAid: 'mostActiveContracts',
		},
	},
	snapshot: {
		container: {
			dataAid: 'optionSnapshot',
		},
		title: {
			text: 'Options snapshot',
			dataAid: 'optionSnapshot',
		},
	},
};

const ANALYST_VIEW = {
	screenDataAid: 'scripAnalystView',
	navHeaderDataAid: 'scripAnalystView',
	NO_DATA_AVAILABLE: 'Analyst view is not available for this stock',
	analystConsensus: {
		dataAid: 'analystConsensus',
		title: {
			text: 'Analyst consensus',
			dataAid: 'analystConsensus',
		},
		subtitle: {
			dataAid: 'analystConsensusSubtitle',
		},
		noteText: {
			text: 'Understand analyst consensus',
			dataAid: 'note',
		},
		tooltip: {
			text: "Analysts' forecast on company's performance shown via various consensus measures like earnings per shares, sales & net income",
			dataAid: 'analystConsensus',
			iconDataAid: 'info',
		},
	},
	ratings: {
		dataAid: 'ratings',
		title: {
			text: 'Ratings',
			dataAid: 'ratings',
		},
		note: {
			text: 'Rating Scale: 1-10. Higher is Better.',
			dataAid: 'note',
		},
	},
	averageScoreTrend: {
		dataAid: 'averageScoreTrend',
		title: {
			text: 'Average score trend',
			dataAid: 'averageScoreTrend',
		},
	},
	sectorMarketApp: {
		dataAid: 'sector&MarketCap',
		title: {
			text: 'Sector & market cap',
			dataAid: 'sector&MarketCap',
		},
		leftLabelOne: {
			text: 'Sector',
			dataAid: 'sectorKey',
		},
		leftLabelTwo: {
			text: 'Market cap',
			dataAid: 'marketCapKey',
		},
		rightLabelOne: {
			dataAid: 'sectorValue',
		},
		rightLabelTwo: {
			dataAid: 'marketCapValue',
		},
	},
	outlook: {
		dataAid: 'outlook',
		title: {
			text: 'Outlook',
			dataAid: 'sector&MarketCap',
		},
	},
	priceTarget: {
		dataAid: '12monthPrice',
		title: {
			text: '12 month price target',
			dataAid: '12monthPriceTarget',
		},
		note: {
			text: 'Understand price target',
			dataAid: 'note',
		},
		tooltip: {
			text: 'The estimated future price of stocks over a given time period',
			dataAid: 'priceTarget',
			iconDataAid: 'info',
		},
		chartTitle: 'Price',
	},
	scoreCard: {
		dataAid: 'scoreCard',
		scoreDataAid: 'score',
		titleDataAid: 'title',
		subtitleDataAid: 'subtitle',
		downLoadButton: {
			text: 'Download report',
			dataAid: 'download',
			iconDataAid: 'download',
		},
		superScore: {
			text: 'Super score',
			dataAid: 'superScore',
		},
		getFreeReport: {
			dataAid: 'content',
			text: 'Get a free report worth ₹2,399 today!',
		},
		noReportAvailable: 'report not available,please try after sometime',
	},
	footer: {
		report: {
			text: 'These premium reports worth ₹2399 per annum can be downloaded for free*',
			dataAid: 'title',
		},
		limited: {
			text: '*Offer valid for a limited period',
			dataAid: 'subtitle',
		},
		refinitiv: {
			text: 'Aggregated by Refinitiv',
			dataAid: 'note',
		},
		tooltip: {
			text: "Analysts' forecast on company's performance shown via various consensus measures like earnings per shares, sales & net income",
			dataAid: 'analystConsensus',
			iconDataAid: 'info',
		},
	},
};

const FUTURE_SCRIP_SELECTION = {
	radioDatAid: 'left',
	expiryDataAid: 'expiryName',
	discountDataAid: 'premiumDiscount',
	scripValDataAid: 'value',
	valueChangeDataAid: 'valueChange',
	percentChangeDataAid: 'valuePercentage',
};

const SCRIP_INFO_CARD = {
	testId: {
		scripTicker: 'scripTicker',
		scripName: 'scripName',
		tagExchange: 'exchange',
		tagCategory: 'category',
		icon: 'watchlist',
	},
};

const SOCKET_FEED = {
	title: {
		dataAid: 'infoText',
	},
	button: {
		text: 'Refresh',
		dataAid: 'refresh',
	},
	icon: {
		dataAid: 'refresh',
	},
};

const MARKET_DEPTH = {
	groupDataAid: 'grp_marketDepth',
	title: {
		text: 'Market depth',
		dataAid: 'marketDepth',
	},
	total_bids: {
		text: 'Total Bids',
		dataAid: 'totalBids',
	},
	total_asks: {
		text: 'Total Asks',
		dataAid: 'totalAsks',
	},
	bidValue: {
		dataAid: 'bidValue',
	},
	bidPercent: {
		dataAid: 'bidPercentage',
	},
	askValue: {
		dataAid: 'askValue',
	},
	askPercent: {
		dataAid: 'askPercentage',
	},
	titleBid: {
		text: 'Bid',
		dataAid: 'titlesBidBuy',
	},
	titleAsk: {
		text: 'Ask',
		dataAid: 'titlesBidSell',
	},
	titleOrders: {
		text: 'Orders',
		dataAid: 'titleOrdersBuy',
	},
	titleQty: {
		text: 'Qty',
		dataAid: 'titleQtyBuy',
	},
	titlesBuy: {
		dataAid: 'grp_titlesBuy',
	},
	titlesSell: {
		dataAid: 'grp_titlesSell',
	},
	buyTable: {
		dataAid: 'grp_buy',
	},
	sellTable: {
		dataAid: 'grp_sell',
	},
	bidBuy: {
		dataAid: 'bidBuy',
	},
	bidSell: {
		dataAid: 'bidSell',
	},
	ordersBuy: {
		dataAid: 'ordersBuy',
	},
	ordersSell: {
		dataAid: 'ordersSell',
	},
	qtySell: {
		dataAid: 'qtySell',
	},
	qtyBuy: {
		dataAid: 'qtyBuy',
	},
};

const CONSTITUENTS_TAB = {
	totalConstituentsCompanies: {
		text: 'Constituents',
		dataAid: 'companies',
	},
	totalConstituents: {
		dataAid: 'value',
	},
	sort: {
		dataAid: 'sort',
		text: 'Sort',
	},
	ctaBtn: {
		text: 'View Option Chain',
	},
};

const ACTIVATE_FNO = {
	dataAid: 'activateFutureOptionCard',
	title: {
		text: 'Activate F&O',
		dataAid: 'activateFno',
	},
	subtitle: {
		text: 'Upload bank statement & start trading',
		dataAid: 'uploadBankStatement',
	},
};

const CURRENT_HOLDING_STRING = {
	title: {
		text: 'Current Holding',
		dataAid: 'currentHolding',
	},
	investedAmount: {
		text: 'Invested amount',
		dataAid: 'investedKey',
		valueDataAid: 'investedValue',
	},
	qty: {
		text: 'Qty ',
		dataAid: 'key',
		valueDataAid: 'value',
	},
	avg: {
		text: 'Avg ',
		title: 'Avg',
		dataAid: 'key',
		valueDataAid: 'value',
	},
	currentValue: {
		text: 'Current value',
		dataAid: 'currentKey',
		valueDataAid: 'currentValue',
	},
	overallPnl: {
		dataAid: 'profit',
	},
	overallPnlPerc: {
		dataAid: 'profitPercentage',
	},
};

const SCRIP_HEADER = {
	refresh: 'Refresh',
	errorText: 'Unable to load data',
};
const REFINITIVE_CARD = {
	title: 'Aggregated by Refinitiv',
	btmTitle: 'Refinitiv I/B/E/S data estimates',
	ctaTitle: 'CLOSE',
	contentText:
		"The Institutional Brokers' Estimate System (I/B/E/S) is a database of estimates made by\n" +
		'\t\t\t\t\t\t\t\tstock analysts regarding the future earnings of publicly traded companies. It offers\n' +
		'\t\t\t\t\t\t\t\tanalyst forecast regarding company performance, encompassing consensus measures such as\n' +
		"\t\t\t\t\t\t\t\tearnings per share, sales, and net income.These estimates are displayed 'AS IS' by\n" +
		'\t\t\t\t\t\t\t\tFinwizard Technologies Pvt Ltd and should not be interpreted as investment advice or an\n' +
		'\t\t\t\t\t\t\t\toffer to buy/sell securities. Investors should make investment decisions based on their\n' +
		'\t\t\t\t\t\t\t\town objectives, judgment, risk profile, and financial position, while thoroughly\n' +
		'\t\t\t\t\t\t\t\treviewing all associated documents. Please note that past performance is not indicative\n' +
		'\t\t\t\t\t\t\t\tof future results, and investing in securities markets involves inherent market risks',
};
export const SCRIP_DETAIL_STRING = {
	SCRIP_HEADER,
	LIVE_STATS_STRING,
	CURRENT_HOLDING_STRING,
	CONSTITUENTS_TAB,
	MARKET_DEPTH,
	SCRIP_INFO_CARD,
	SCRIP_DETAIL,
	FUNDAMENTALS,
	ACTIVATE_FNO,
	ANALYST_VIEW,
	FUTURE_SCRIP_SELECTION,
	FO_VIEW,
	OPTION_CHAIN,
	TECHNICALS,
	NEWS_EVENTS,
	REFINITIVE_CARD,
};
